export default "__VITE_ASSET__CW5BNJz9__"